import { useGridApiContext, useGridSelector, gridPageSelector, gridPageCountSelector, gridPageSizeSelector } from "@mui/x-data-grid";
import { Box, IconButton, MenuItem, Pagination, Select, Typography } from "@mui/material";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";

export default function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);

  return (
    <Box display='flex' alignItems='center' justifyContent='space-between' px={2} py={1}>
      <Box display='flex' alignItems='center' gap={16}>
        <Typography variant='body2'>Rows per page</Typography>
        <Select size='small' value={pageSize} onChange={(e) => apiRef.current.setPageSize(Number(e.target.value))}>
          {[10, 20, 50, 100].map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box display='flex' alignItems='center' gap={1}>
        <IconButton onClick={() => apiRef.current.setPage(0)} disabled={page === 0}>
          <FirstPageIcon />
        </IconButton>

        <Pagination
          count={pageCount} // Use dynamic pageCount instead of 10
          page={page + 1}
          onChange={(_, value) => apiRef.current.setPage(value - 1)}
          siblingCount={0}
          boundaryCount={1}
        />

        <IconButton onClick={() => apiRef.current.setPage(pageCount - 1)} disabled={page >= pageCount - 1}>
          <LastPageIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
